import { cn } from "@/lib/utils";
import { tdata } from "./data";
import ProductCard from "./product-card";
import ProductCardLoader from "./product-card-loader";
import { Product } from "../types";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { useElementVisibility } from "../hook/use-element-visibility";

export default function InlineBlock({
  type = "similar",
  lst = [],
  title,
}: {
  type: "similar" | "complementary" | "location" | "manual";
  lst?: Product[];
  title?: string;
}) {
  const [elementRef] = useElementVisibility<HTMLDivElement>({
    data: {
      name: "inline-block",
      properties: {
        category: "inline-block",
      },
    },
  });
  const loading = false;
  return (
    <>
      {title && <h5 className="hp-text-xl hp-font-semibold">{title}</h5>}
      <div
        ref={elementRef}
        data-helium-anme="product-list"
        className="hp-w-full"
      >
        {loading && <ProductCardLoader />}
        <ul className="swimlane2 no-scrollbar hp-flex hp-w-full hp-place-items-center hp-pl-0">
          {!loading &&
            lst.map((item) => (
              <ProductCard
                key={item.id}
                product={item}
                className="w-[200px] min-w-[200px]"
              />
            ))}
        </ul>
        {!loading && lst.length === 0 && (
          <div className="hp-px-4 hp-text-center">No {type} products found</div>
        )}
      </div>
    </>
  );
}
